import fipayFonts from "../../theme/index";
import React, { useState } from "react";
import styled from "styled-components";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

interface CommonQuestionProps {}

const CommonQuestion: React.FC<CommonQuestionProps> = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "Lorem ipsum dolor sit amet consectetur eget viverra?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      question: "Lorem ipsum dolor sit amet consectetur eget viverra?",
      answer:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    {
      question: "Lorem ipsum dolor sit amet consectetur eget viverra?",
      answer:
        "Contrary to popular belief, Lorem Ipsum is not simply random text.",
    },
    {
      question: "Lorem ipsum dolor sit amet consectetur eget viverra?",
      answer: "There are many variations of passages of Lorem Ipsum available.",
    },
    {
      question: "Lorem ipsum dolor sit amet consectetur eget viverra?",
      answer: "Yes, it is safe to use Lorem Ipsum.",
    },
    {
      question: "Lorem ipsum dolor sit amet consectetur eget viverra?",
      answer: "Yes, there are trustworthy Lorem Ipsum generators available.",
    },
  ];

  interface CommonQuestionProps {}

  const images = [
    {
      TextHeader: "Commonly asked questions",
      MidFirstText: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus
        libero nulla, nec dignissim nisi semper ac. Pellentesque lorem leo, tempus at semper nec, 
        auctor ac nibh nec dignissim nisi semper ac.`,
      MidSecondText: `In hac habitasse platea dictumst. Vivamus
        vestibulum tortor ac leo maximus, vitae tincidunt diam molestie. Aenean
        eu leo quam. Pellentesque lorem leo, tempus at semper nec, auctor ac
        nibh nec dignissim nisi semper ac.`,
    },
  ];

  const toggleAnswer = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <CommonQuestionContainer>
      <CommonQuestionCText>
        <AboutUsContainer>
          <AboutUsText>FAQs</AboutUsText>
        </AboutUsContainer>
        <OurVisionTitle>Commonly asked questions</OurVisionTitle>
      </CommonQuestionCText>
      <FaqList>
        {faqs.map((faq, index) => (
          <FaqContainer key={index}>
            <Question onClick={() => toggleAnswer(index)}>
              {faq.question}
              <IconWrapper>
                {openIndex === index ? (
                  <StyledChevronUp />
                ) : (
                  <StyledChevronDown />
                )}
              </IconWrapper>
            </Question>
            {openIndex === index && <Answer>{faq.answer}</Answer>}
            <HorizontalLine />
          </FaqContainer>
        ))}
      </FaqList>
    </CommonQuestionContainer>
  );
};

const CommonQuestionContainer = styled.section`
  display: flex;
  align-items: flex-start; /* Align items to the start */
  justify-content: space-between;
  background-color: #f7f7f7;
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 3rem;
  padding-right: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 4rem 1rem;
  }
`;

const CommonQuestionCText = styled.div`
  width: 50%;
  flex-direction: column;
  margin-top: 5.25rem;
  margin-left: 7rem;
  margin-bottom: 5.25rem;
  margin-right: 2rem;

  @media (max-width: 850px) {
    width: 100%;
    align-items: left;
    padding: 1rem;
    margin: 1rem 0rem;
  }
`;

const AboutUsText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #00c703;
`;

const AboutUsContainer = styled.div`
  background-color: #fff;
  border-radius: 30px;
  text-align: center;
  display: inline-block;
  width: 24%;
  height: 1%;
  margin-bottom: 1px;

  @media (max-width: 850px) {
    width: 50%;
    height: 1%;
    margin-left: 1rem;
  }
`;

const OurVisionTitle = styled.h1`
  font-size: 45px;
  font-weight: 700;
  line-height: 64px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 20px;
  color: #09005b;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin-left: 1rem;
  }
`;

const FaqList = styled.div`
  width: 50%; /* Adjust the width as needed */
  display: flex;
  flex-direction: column;
  margin-top: 5.25rem;
  margin-right: 7rem;
  margin-bottom: 5.25rem;
  margin-left: 2rem;

  @media (max-width: 768px) {
    align-items: left;
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;

const FaqContainer = styled.div`
  margin-bottom: 20px;
  @media (max-width: 768px) {
    align-items: left;
    width: 100%;
    margin: 0;
    padding: 1rem;
  }
`;

const Question = styled.div`
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  color: #363636;
  margin-bottom: 20px;
  margin-right: 40px;
  position: relative;
  padding-right: 2rem;

  &:hover {
  }
`;

const IconWrapper = styled.div`
  position: absolute; /* Position the icon absolutely */
  right: 0; /* Push it to the extreme right */
  transform: translateY(-50%); /* Center vertically */
  top: 0px;
`;
const StyledChevronDown = styled(BsChevronDown)`
  /* Add styling for the down chevron */
  font-size: 20px;
  color: #0e0e0e;
  width: 18px;
  height: 18px;
`;

const StyledChevronUp = styled(BsChevronUp)`
  /* Add styling for the up chevron */
  font-size: 20px;
  color: #0e0e0e;
  width: 18px;
  height: 18px;
`;

const Answer = styled.div`
  margin-top: 10px;
`;

const HorizontalLine = styled.hr`
  border: 0.5px solid #e8eaed;
  width: 100%;
`;

export default CommonQuestion;
